export default __webpack_public_path__ + "fa4b36b5d60398c5bb1316154f3f1ad9.svg";